import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOmeMeetEntryInvitationsData from './GetOmeMeetEntryInvitationsData';
import postOmeMeetEntryInvitationsData from './PostOmeMeetEntryInvitationsData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
};

const OmeMeetEntryInvitationsData = {
  INITIAL_STATE,
  getOmeMeetEntryInvitationsData,
  postOmeMeetEntryInvitationsData
};

export default OmeMeetEntryInvitationsData;